import { FetchRequest, FetchResponse } from '@rails/request.js'

interface SearchArgs {
  identity: string
  name: string
}

interface SearchResponse extends FetchResponse {
  get json(): Promise<Lock | null>
}

export function search({ identity, name }: SearchArgs): Promise<SearchResponse> {
  const endpoint = `/identities/${identity}/integrations/${name}/search`

  return new FetchRequest('get', endpoint).perform()
}
